import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import addREC from "../../../../../assets/icons/addREC.svg";
import CompanyDashboardInitiativeDrawerSideBarTimelinePopup from "./company-dashboard-initiative-drawer-side-bar-timeline-popup";
import "./company-dashboard-initiative-drawer-side-bar.scss";

const CompanyDashboardInitiativeDrawerSideBarTimeline: any = (props: any) => {// NOSONAR
  const {
    timelineData,
    setTimelineData,
    initiativeIdTooltip,
    initiativeId,
    handleCreateInitiative,
    payloadData,
    canEdit,
    canWrite,
    dateFormat,
    initiativeDataPermissions,
  } = props;
  const [isShowEditTimeline, setIsShowEditTimeline] = useState(false);

  let actionIcon: React.ReactNode = null;
  if (initiativeId && timelineData?.startDate && timelineData?.endDate) {
    if (canEdit && initiativeDataPermissions) {
      actionIcon = <img src={editIcons} alt="edit" />;
    } else if (canWrite && initiativeDataPermissions) {
      actionIcon = <img src={addREC} alt="add" />;
    }
  } else if (canWrite && initiativeDataPermissions) {
    actionIcon = <img src={addREC} alt="add" />;
  } else if (canEdit && initiativeDataPermissions) {
    actionIcon = <img src={editIcons} alt="edit" />;
  }

  return (
    <>
      <div className="company-dashboard-initiative-drawer-side-bar-content-header">
        <div>Timeline</div>
        <Tooltip title={initiativeIdTooltip}>
          <button
            className="company-dashboard-initiative-drawer-side-bar-content-header-edit-icon"
            onClick={() => {
              if (initiativeId && canEdit) setIsShowEditTimeline(true);
            }}
            style={{
              cursor:
                !initiativeId || (!canEdit && !canWrite)
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            {actionIcon}
          </button>
        </Tooltip>
      </div>
      <div className="company-dashboard-initiative-drawer-side-bar-content-timeline">
        <div className="company-dashboard-initiative-drawer-side-bar-content-timeline-content">
          <div className="company-dashboard-initiative-drawer-side-bar-content-timeline-content-item">
            <div className="timeline-label">
              <i className="fa fa-calendar" aria-hidden="true" /> Start Date
            </div>
            <div className="timeline-label">
              <i className="fa fa-calendar" aria-hidden="true" /> End Date
            </div>
          </div>
          <div className="company-dashboard-initiative-drawer-side-bar-content-timeline-content-item">
            <div className="timeline-value">
              {timelineData?.startDate
                ? dayjs(timelineData.startDate).format("MM-DD-YYYY")
                : "MM-DD-YYYY"}
            </div>
            <div className="timeline-value">
              {timelineData?.endDate
                ? dayjs(timelineData.endDate).format("MM-DD-YYYY")
                : "MM-DD-YYYY"}
            </div>
          </div>
        </div>
      </div>
      <CompanyDashboardInitiativeDrawerSideBarTimelinePopup
        isShowEditTimeline={isShowEditTimeline}
        setIsShowEditTimeline={setIsShowEditTimeline}
        timelineData={timelineData}
        setTimelineData={setTimelineData}
        handleCreateInitiative={handleCreateInitiative}
        payloadData={payloadData}
        dateFormat={dateFormat}
      />
    </>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarTimeline;
